export default __webpack_public_path__ + "static/media/20081229_1523_R.5b9811ab.jpg";